module.exports = __webpack_public_path__ + "static/media/full_time_teaching_position_en.4cac21e3.jpg";